import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import SearchBar from "./SearchBar";
import HelpMessage from "./HelpMessage";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";

const EditNotes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { note } = location.state || {}; // Retrieve note data from location state
  // State to hold the edited note
  // Get the current date in the specified format
  const currentDate = moment(new Date()).format("DD/MM/YYYY");
  const [editedNote, setEditedNote] = useState(note ? note.notes1 : "");

  const [subNotesChecked, setSubNotesChecked] = useState(false);

  const [subNotes, setSubNotes] = useState([]);

  const [fieldData, setFieldData] = useState({
    supplier: note ? note.supplier : "",
    eventType: note ? note.type : "",
  });

  const handleNoteUpdate = async () => {
    if (!note) {
      // Handle the case when no note data is available
      return;
    }
    // Prepare the data to be sent to the server for updating the note
    const dataToUpdate = {
      ID: note.Id, // Add the note ID for identification
      note: editedNote, // Updated note content,
      eventType: fieldData.eventType,
    };

    // Make the API request to update the note
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASEURL}/api/notes/${note.Id}`,
        dataToUpdate
      );

      // Handle the response or any errors as needed
      console.log("Note updated successfully:", response.data);

      // Redirect back to the "Notes" page after updating
      navigate("/Notes");
    } catch (error) {
      console.error("Error updating note:", error);
    }
  };

  const [supplierOptions, setSupplierOptions] = useState([]);
  const [eventTypeOptions, setEventTypeOptions] = useState([]);

  useEffect(() => {
    const fetchEventSupplierOptions = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASEURL}/api/eventTypeSupplierOptions`,
          {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              }
          }
        );
        
        setSupplierOptions(response.data.supplier);
        setEventTypeOptions(response.data.eventType);
        
      } catch (error) {
        console.error("Error fetching data:", error);
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASEURL}/api/getSubNotes/${note.indexkey}`,
          {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              }
          }
        );
        
        setSubNotes(response.data.subNotes);
        
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setSubNotesChecked(true);
      }
    };

    fetchEventSupplierOptions();
  }, []);

  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Notes</a>
          </div>
          <div className="" id="result-wrapper">
            <SearchBar />

            { ! subNotesChecked ? <>
              <div className="row">
                <div className="col-sm-12">Loading Data...</div>
              </div>
            </> : <>
              <form id="frmNotes" name="Notes" noValidate>
                <div className="margin_tops notes-wrap" id="result-wrappers">
                  <div className="row">
                    <div className="col-sm-3 form-group">
                      <label >
                        EVENT TYPE <span className="req-error">*</span> :
                      </label>
                      <select
                        className="form-control"
                        id="Type"
                        name="Type"
                        value={fieldData.eventType} // Set the initial selected value as 'AGRO'
                        onChange={(e) => {
                          setFieldData( {
                            ...fieldData,
                            eventType: e.target.value
                          } )
                        }}
                      >
                        <option value="">--Select--</option>
                        {eventTypeOptions.map((option) => (
                          <option key={option.code} value={option.code}>
                            {option.descript}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-3 form-group">
                      <label >
                        CREATED DATE
                        <span className="req-error"> * </span> :
                      </label>

                      <input
                        className="form-control"
                        defaultValue={currentDate}
                        disabled
                        id="createdDate"
                        type="text"
                      />
                    </div>

                    <div className="col-sm-3 form-group">
                      <label >
                        SUPPLIER
                        <span className="req-error"> * </span> :
                      </label>
                      <select
                        className="form-control"
                        id="Supplier"
                        name="Supplier"
                        disabled
                        value={fieldData.supplier}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          setFieldData( {
                            ...fieldData,
                            supplier: selectedValue
                          } )
                        }}
                      >
                        <option value=" ">--Select--</option>
                        {supplierOptions.map((option) => (
                          <option key={option.supplier} value={option.supplier}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 form-group">
                      <label >
                        NOTES <span className="req-error"> * </span> :
                      </label>
                      <textarea
                        className="form-control"
                        value={editedNote}
                        onChange={(e) => setEditedNote(e.target.value)}
                        maxLength="99"
                        name="Notes"
                        rows="5"
                        style={{
                          width: "100%",
                        }}
                      />
                    </div>
                  </div>
                  {subNotes.length > 0 && (
                    <div className="row">
                      <div className="col-md-12">
                        <h3 className="mb-1 mt-1">SUBNOTES</h3>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-12">
                      <table className="tblViewNotes" id="resultdetail">
                        <tbody>
                          {subNotes.map((subNote, index) => (
                            <tr key={subNote.Id} className={index % 2 === 0 ? "even" : "odd"}>
                              <td className="viewnotes_incident">{subNote.notes}</td>
                              <td className="viewnotes_date">
                                {moment(subNote.fdate).format("DD/MM/YYYY")}{" "}
                                <i
                                  className="fas fa-pen-square"
                                  id="Editz0"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    navigate("/Notes/EditSubnote/" + subNote.Id, { state: { note: note } });
                                  }}
                                />
                              </td>  
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="subnot-btn-wrap mb-1">
                    <div className="row">
                      <div className="col-md-3">
                        <button
                          className="btn btn-primary btn-lg"
                          type="button"
                          onClick={() => {
                            navigate("/Notes/AddSubnote/" + note.Id, { state: { note: note } });
                          }}
                        >
                          <span className="glyphicon glyphicon-plus" />
                          <span>ADD SUBNOTES</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="save-cancle-btn-wrap mt-1">
                    <div className="row save-cancle-btn-wrap">
                      <div className="col-lg-2 col-md-2">
                        <button
                          className="btn  btn-lg btn-primary"
                          type="button"
                          onClick={handleNoteUpdate}
                        >
                          <span className="glyphicon glyphicon-floppy-disk" />
                          <span>SAVE</span>
                        </button>
                      </div>

                      <div className="col-lg-2 col-md-2">
                        <button
                          className="btn btn-lg btn-default"
                          type="button"
                          onClick={() => {
                            navigate("/Notes");
                          }}
                        >
                          <span className="glyphicon glyphicon-remove" />
                          <span>CANCEL</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <HelpMessage />
              </form>
            </> }
          </div>
        </div>
      </div>
    </>
  );
};

export default EditNotes;
